import React from "react";
import { Outlet } from "react-router-dom";
import GlobalSpinner from "../components/GlobalSpinner/GlobalSpinner";
import AuthModal from "../components/AuthModal/AuthModal";

export default function MainLayout() {
  return (
    <>
      <GlobalSpinner />
      <AuthModal />
      <Outlet />
    </>
  );
}
